import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../../config/config';

export interface StaffSubject {
  name: string;
}

export interface StaffListItem {
  staffId: number;
  staffName: string;
  staffImage: string | null;
  isClassTeacher: boolean;
  subjects: StaffSubject[];
}

export interface StaffListBody {
  staffList: StaffListItem[];
}

// My Teacher — a purely informational staff directory scoped to the
// parent's currently active student's class (resolved server-side from the
// authToken; no studentId/classId is sent). No pagination, no search/
// filter, and deliberately no tap-to-chat here — separate from the Chat
// feature despite both surfacing staff data, per the API reference this
// was built from.
@Injectable({ providedIn: 'root' })
export class ParentMyTeacherService {

  private base = AppSettings.API_ENDPOINT_STAFF;

  constructor(private http: HttpClient) { }

  private authHeaders(): HttpHeaders | undefined {
    const raw = localStorage.getItem('authToken');
    if (!raw) { return undefined; }
    try {
      return new HttpHeaders().append('authToken', JSON.parse(raw));
    } catch {
      return new HttpHeaders().append('authToken', raw);
    }
  }

  getClassStaffList() {
    // lang is deliberately always 'en' — see the same constraint applied
    // across every other parent-portal endpoint in this app.
    return this.http.get(`${this.base}/get/class/staff/list/for/parent`, {
      headers: this.authHeaders(),
      params: { lang: 'en' },
    });
  }
}
